import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import portada from "../assets/portada.png";
import { useAuth } from "../hooks/useAuth";
import { useForm } from "../hooks/useForm";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../helpers/Routes";
import { useTitle } from "../hooks/useTitle";
const Registro = () => {
    const { signIn, autenticado, signUp } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const { form, onChange, resetForm } = useForm({ usuario: "", email: "", password: "", cedula: "" });
    const { usuario, email, password, cedula } = form;

    const title = `Registro de usuario`;
    useTitle({ title });

    let navigate = useNavigate();
    let location = useLocation();

    let from = location.state?.from?.pathname || routes.login;

    //useEffect para validar si existe una sesion abierta
    useEffect(() => {
        if (autenticado) navigate(from, { replace: true });
    }, [autenticado, navigate, from]);

    useEffect(() => {
        if (autenticado) {
            navigate(routes.home)
        }
    }, [autenticado])

    const handleLogin = (e) => {
        e.preventDefault();
        if (usuario?.trim() === "" || email?.trim() === "" || password?.trim() === "" || cedula?.trim() === "") {
            enqueueSnackbar("Todos los campos son obligatorios", {
                variant: "error",
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                }
            });
            return;
        }


        signUp({ usuario, email, password, cedula }).then((res) => {
            if (res.status === 200) {
                enqueueSnackbar("El usuario se registro con exito", {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "right"
                    }
                })
            }
        }).finally(() => resetForm());
    }
    return (
        <>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header />
                <div className="banner-productos">
                    <div className="portada">
                        <img src={portada} />
                        <p>Registro</p>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="info-contact">
                        <div style={{ flex: "0 0 70%" }}>
                            <h1>Crear una cuenta</h1>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                <div className="form-contact">
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <label>Nombre completo</label>
                                        <input type="text" name="usuario" id="usuario" value={usuario} onChange={(event) => onChange(event, "usuario")} placeholder="Escribe tu nombre completo" />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <label>Cedula de ciudadanía</label>
                                        <input type="number" name="cedula" id="cedula" value={cedula} onChange={(event) => onChange(event, "cedula")} placeholder="Escribe tu cedula" />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <label>Correo electrónico</label>
                                        <input type="email" name="email" id="email" value={email} onChange={(event) => onChange(event, "email")} placeholder="Escribe tu correo electrónico" />
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <label>Contraseña</label>
                                        <input type="password" id="password" name="password" placeholder="Escribe tu contraseña" value={password} onChange={(event) => onChange(event, "password")} />
                                    </div>
                                    <div>
                                        <button className="btn" onClick={handleLogin}>Registrarse</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div >
                <Footer />
            </div >
        </>
    );
}

export default Registro;